import { Popover, Divider, Alert, Icon } from 'antd';

export default class PasswordRequirementsIndicator extends React.Component {
    constructor(props) { super(props); }
    render() {
        const { children, requirementsMet } = this.props;
        return (
            <Popover
                placement='left'
                trigger='focus'
                content={(
                    <div style={{ width: '370px' }}>
                        { /* <Divider type='horizontal' style={{ margin: '13px 0px 10px 0px' }} /> */ }
                        <Divider style={{ margin: '13px 0px 10px 0px' }}>
                            <Alert
                                type={
                                    requirementsMet == null ? 'info' :
                                    requirementsMet ? 'success' :
                                    'error'
                                }
                                style={{ borderRadius: '20px' }}
                                message={(
                                    <div style={{
                                        width: '200px',
                                        color:
                                            requirementsMet == null ? 'rgb(105, 173, 215)' :
                                            requirementsMet ? 'rgb(153, 205, 113)' :
                                            'rgb(225, 133, 128)'
                                    }}>
                                        <Icon
                                            type={
                                                requirementsMet == null ? 'info-circle-o' :
                                                requirementsMet ? 'check-circle-o' :
                                                'close-circle-o'
                                            }
                                            style={{ fontWeight: 'bold', marginRight: '8px' }}
                                        />
                                        <span style={{ fontSize: '12px', fontStyle: 'italic' }}>
                                            {'Password Requirements'}
                                        </span>
                                    </div>
                                )}
                            />
                        </Divider>
                         <div>
                            <ul style={{ lineHeight: '17px' }}>
                                <li>{'Minimum length of 12 characters'}</li>
                                <li>{'At least one upper-case letter'}</li>
                                <li>{'At least one lower-case letter'}</li>
                                <li>{'At least one number'}</li>
                                <li>{'At least one special character (such as: * & $ % ^ ( ) # @ ! ~)'}</li>
                                <li>{'Not the same as your 10 previously used passwords'}</li>
                            </ul>
                        </div> 
                    </div>
                )}
            >
                {children}
            </Popover>
        );
    }
}
